import React from 'react';
import CustomAddPage from 'components/custom-pages/CustomAddPage';

const Add = ({ data, handleClick }) => {
  const initialValues = {
    name: data?.name || '',
  };

  const inputFields = [
    {
      name: 'name',
      label: 'Mechanical Condition Reason',
      type: 'text',
      required: true,
    },
  ];

  return (
    <CustomAddPage
      pageTitle={
        data
          ? 'Update Mechanical Condition Reason'
          : 'Add Mechanical Condition Reason'
      }
      url={'mechanical-condition-reason-master'}
      action={!data ? 'create' : 'update'}
      updateId={data?._id}
      queryKey="mechanical-condition-reason-master"
      inputFields={inputFields}
      data={initialValues}
      handleClick={handleClick}
    />
  );
};

export default Add;
